import { EmailLink, FacebookLink, LinkedInLink, TwitterLink } from '@/components/ui/icons/SocialIcons';
import styled, { css } from 'styled-components';

import NewsletterForm from '../NewsletterForm';
import breakpoint from 'styled-components-breakpoint';
import { pathOr } from 'ramda';
import { theme } from 'styled-tools';

const Socials = styled.aside`
  width: 100%;
  ${(props) =>
    props.inBlogPost
      ? css`
          ${breakpoint('xs')`
            margin-top: 5rem;
          `};
          ${breakpoint('sm')`
            max-width: 50%;
          `};
          ${breakpoint('md')`
            margin-left: auto;
            margin-top: 0;
            max-width: 100%;
            width: 95%;
          `};
        `
      : ''};
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
  margin-top: 0.75em;

  ${(props) =>
    props.inBlogPost
      ? css`
          display: flex;
          justify-content: space-around;
        `
      : ''}

  ${breakpoint('xs', 'md')`
    display: inline-block;
    margin-bottom: 3rem;
  `};
`;

const ListItem = styled.li`
  margin: 0;
  padding: 0;
  list-style: none;

  ${breakpoint('xs', 'md')`
    display: inline-block;
    margin-right: 2rem;
  `};
  ${breakpoint('md')`
    margin-bottom: 2rem;
  `};

  svg {
    color: ${theme('colors.blue')};
    &:hover {
      color: ${theme('colors.orange')};
    }
  }
  a {
    vertical-align: text-top;
    :hover {
      opacity: 1;
    }
  }
`;

const getImg = pathOr(null, ['childImageSharp', 'fluid']);

const PostSocials = ({ permalink, title, description, image, inBlogPost = false, minimal = false }) => {
  const imgUrl = typeof image === 'string' ? image : getImg(image);

  const shareParams = { title, desc: description, image: imgUrl };
  return (
    <Socials inBlogPost={inBlogPost}>
      {!minimal && <span>Share this post:</span>}
      <List inBlogPost={inBlogPost}>
        <ListItem>
          <LinkedInLink url={permalink} size={32} share={true} shareParams={shareParams} />
        </ListItem>
        <ListItem>
          <TwitterLink url={permalink} size={32} share shareParams={shareParams} />
        </ListItem>
        <ListItem>
          <FacebookLink url={permalink} size={32} share shareParams={shareParams} />
        </ListItem>
        {!minimal && (
          <ListItem>
            <EmailLink url={permalink} size={32} share shareParams={shareParams} />
          </ListItem>
        )}
      </List>
      {!minimal && <NewsletterForm inBlogPost={inBlogPost} />}
    </Socials>
  );
};

export default PostSocials;
